export const AddPatientModal = ({
  newPatientData,
  setNewPatientData,
  patientModalError,
  onConfirm,
  onCancel,
}) => {
  const isValid = newPatientData.fullName.trim() && newPatientData.email.trim() && newPatientData.dateOfBirth.trim();

  const maxDob = (() => {
    const today = new Date();
    const twoYearsAgo = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
    return twoYearsAgo.toISOString().split('T')[0];
  })();

  const inputStyle = {
    width: '100%', padding: '0.75rem',
    border: '2px solid #e2e8f0', borderRadius: '8px', fontSize: '1rem'
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: '12px', padding: '2rem',
        maxWidth: '500px', width: '90%', maxHeight: '90vh', overflowY: 'auto'
      }}>
        <h2 style={{ marginTop: 0, color: '#2d3748', fontSize: '1.5rem' }}>Add New Patient</h2>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#4a5568' }}>
            Full Name <span style={{ color: '#e53e3e' }}>*</span>
          </label>
          <input
            type="text"
            value={newPatientData.fullName}
            onChange={(e) => setNewPatientData({ ...newPatientData, fullName: e.target.value })}
            placeholder="John Doe"
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#4a5568' }}>
            Email <span style={{ color: '#e53e3e' }}>*</span>
          </label>
          <input
            type="email"
            value={newPatientData.email}
            onChange={(e) => setNewPatientData({ ...newPatientData, email: e.target.value })}
            placeholder="john@example.com"
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#4a5568' }}>
            Date of Birth <span style={{ color: '#e53e3e' }}>*</span>
          </label>
          <input
            type="date"
            value={newPatientData.dateOfBirth}
            onChange={(e) => setNewPatientData({ ...newPatientData, dateOfBirth: e.target.value })}
            max={maxDob}
            style={inputStyle}
          />
          <div style={{ marginTop: '0.25rem', fontSize: '0.8rem', color: '#718096' }}>
            Patient must be at least 2 years old
          </div>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#4a5568' }}>
            Phone (optional)
          </label>
          <input
            type="tel"
            value={newPatientData.phone}
            onChange={(e) => setNewPatientData({ ...newPatientData, phone: e.target.value })}
            placeholder="+1234567890"
            style={inputStyle}
          />
        </div>

        {patientModalError && (
          <div style={{
            marginBottom: '1rem', padding: '1rem',
            backgroundColor: '#fff5f5', border: '1px solid #fc8181',
            borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '0.75rem'
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#e53e3e" strokeWidth="2"/>
              <path d="M12 8v4M12 16h.01" stroke="#e53e3e" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <span style={{ color: '#c53030', fontSize: '0.95rem', lineHeight: '1.5' }}>
              {patientModalError}
            </span>
          </div>
        )}

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '0.75rem 1.5rem', backgroundColor: '#e2e8f0', color: '#2d3748',
              border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '600', cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={!isValid}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: isValid ? '#48bb78' : '#cbd5e0',
              color: 'white', border: 'none', borderRadius: '8px',
              fontSize: '1rem', fontWeight: '600',
              cursor: isValid ? 'pointer' : 'not-allowed'
            }}
          >
            Create Patient
          </button>
        </div>
      </div>
    </div>
  );
};
